import React from 'react';
import { Spinner } from 'react-bootstrap';

import Header from '../../modules/header'
import Sidebar from '../../modules/sidebar'

function Loading(props) {
  return (
    <div className="loading center">
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  );
}

export default Loading;
